import React, { useState, useEffect } from 'react'
import { SubmitHandler, useForm, UseFormReturn } from 'react-hook-form'
import { BodyParams, ErrorBoxComponent, FieldProps, FormDataBase, FormWrapper, onSubmit } from '../common/FormBase'
import { emailField, idField, langField, nameField, passwordField, phoneNumberField, roleField, usernameField } from '../common/fields'

export interface CompanyFormData extends FormDataBase {
  id?: string
  lang: string
  username: string
  email: string
  phoneNumber: string
  password: string
  passwordRepeat: string
}

export interface CompanyFormParams extends BodyParams<CompanyFormData>{
  onSubmit: onSubmit<CompanyFormData>
}

export const SuperAdminCompanyBody = (params: BodyParams<CompanyFormData>) => {
  const fieldProps: FieldProps<CompanyFormData> = {
    ...params,
    fieldName: ""
  }
  return <>
    {id(fieldProps)}
    {name(fieldProps)}
    {email(fieldProps)}
    {phoneNumber(fieldProps)}
  </>
}

export const SuperAdminEditCompanyForm = (params: CompanyFormParams) => {
  const formHandler: SubmitHandler<CompanyFormData> = (data) => {
    params.onSubmit(data);
  }
  return <FormWrapper<CompanyFormData> {...params}  formName='company' onSubmit={formHandler}>
    <SuperAdminCompanyBody {...params} />
  </FormWrapper>
}

export const SuperAdminInsertCompanyForm = (params: CompanyFormParams) => {
  const formHandler: SubmitHandler<CompanyFormData> = (data) => {
    if (data.password !== data.passwordRepeat) {
      params.form.setError('passwordRepeat', {
        type: 'validate',
        message: params.translates?.for('forms.company.errors.passwordMismatch'),
      })
      return
    }
    params.onSubmit(data);
  }
  return <FormWrapper<CompanyFormData> {...params}  formName='company' onSubmit={formHandler}>
    <SuperAdminCompanyBody {...params} />
  </FormWrapper>
}

export const id = (props: FieldProps<CompanyFormData>) => idField<CompanyFormData>()({...props, fieldName: props.fieldName || "id", formName: props.formName || "company"})
export const name = (props: FieldProps<CompanyFormData>) => nameField<CompanyFormData>()({...props, fieldName: props.fieldName || "name", formName: props.formName || "company"})
export const email = (props: FieldProps<CompanyFormData>) => emailField<CompanyFormData>()({...props, fieldName: props.fieldName || "email", formName: props.formName || "company"})
export const phoneNumber = (props: FieldProps<CompanyFormData>) => phoneNumberField<CompanyFormData>()({...props, fieldName: props.fieldName || "phoneNumber", formName: props.formName || "company"})